import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AddersServicev2 from "./AddersServicev2";

const initialState = {
    adders: [],
    adder_childrens: [],
    adder: [],
    services: [],
    isSuccess: false,
    isLoading: false,
    isError: false,
    errors: [],
    message: null,
};

export const GetAllAdders = createAsyncThunk(
    "adderv2/index",
    async (data, thunkAPI) => {
        let { getState, rejectWithValue } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await AddersServicev2.GetAllAdders(data, token);
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message);
        }
    }
);

export const GetAddersChildrens = createAsyncThunk(
    "adderv2/childrens",
    async (data, thunkAPI) => {
        let { getState, rejectWithValue } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await AddersServicev2.GetAllAdders(data, token);
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message);
        }
    }
);

export const GetSingleAdderMethod = createAsyncThunk(
    "adderv2/show",
    async (id, thunkAPI) => {
        let { getState, rejectWithValue } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await AddersServicev2.GetSingleAdder(id, token);
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message);
        }
    }
);

export const CreateAdderMethod = createAsyncThunk(
    "adderv2/show",
    async (data, thunkAPI) => {
        let { getState, rejectWithValue } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await AddersServicev2.CreateAdder(data, token);
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message);
        }
    }
);

export const UpdateAdderMethod = createAsyncThunk(
    "adderv2/update",
    async (data, thunkAPI) => {
        let { getState, rejectWithValue } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await AddersServicev2.UpdateAdder(data, token);
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message);
        }
    }
);

export const UpdateAdderStatus = createAsyncThunk(
    "adderv2/update",
    async (data, thunkAPI) => {
        let { getState, rejectWithValue } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await AddersServicev2.UpdateAdderStatus(data, token);
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message);
        }
    }
);
export const DeleteAddreMethod = createAsyncThunk(
    "adderv2/delete",
    async (id, thunkAPI) => {
        let { getState, rejectWithValue } = thunkAPI;
        try {
            let token = getState().auth.mainUser.data.token;
            return await AddersServicev2.DeleteAdder(id, token);
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message);
        }
    }
);

export const GetAllServiceTypes = createAsyncThunk(
    "services/get", async (_, thunkAPI) => {
        let { getState, rejectWithValue } = thunkAPI;
        try {
            let token = getState().auth?.mainUser.data.token;
            return await AddersServicev2.GetAllServiceTypes(token)
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message)
        }
    } 
)

const AddersSlicev2 = createSlice({
    name: "adders",
    initialState,
    reducers: {
        adderReset: (state) => {
            state.isSuccess = false;
            state.isLoading = false;
            state.isError = false;
            state.errors = [];
            state.message = null;
        },
    },
    extraReducers: {
        // Get All Adders
        [GetAllAdders.pending]: (state) => {
            state.isLoading = true;
        },
        [GetAllAdders.fulfilled]: (state, action) => {
            state.isSuccess = true;
            state.isLoading = false;
            state.adders = action.payload;
        },
        [GetAllAdders.rejected]: (state, action) => {
            state.isError = true;
            state.isLoading = false;
            state.errors = action.payload;
        },
        [GetAddersChildrens.pending]: (state) => {
            state.isLoading = true;
        },
        [GetAddersChildrens.fulfilled]: (state, action) => {
            state.isSuccess = true;
            state.isLoading = false;
            state.adder_childrens = action.payload;
        },
        [GetAddersChildrens.rejected]: (state, action) => {
            state.isError = true;
            state.isLoading = false;
            state.errors = action.payload;
        },

        // Get Single Adders
        [GetSingleAdderMethod.pending]: (state) => {
            state.isLoading = true;
        },
        [GetSingleAdderMethod.fulfilled]: (state, action) => {
            state.isSuccess = true;
            state.isLoading = false;
            state.adder = action.payload;
        },
        [GetSingleAdderMethod.rejected]: (state, action) => {
            state.isError = true;
            state.isLoading = false;
            state.errors = action.payload;
        },

        // Create Adders
        [CreateAdderMethod.pending]: (state) => {
            state.isLoading = true;
        },
        [CreateAdderMethod.fulfilled]: (state, action) => {
            state.isSuccess = true;
            state.isLoading = false;
            state.adder = action.payload;
        },
        [CreateAdderMethod.rejected]: (state, action) => {
            state.isError = true;
            state.isLoading = false;
            state.errors = action.payload;
        },

        // Update Adders
        [UpdateAdderMethod.pending]: (state) => {
            state.isLoading = true;
        },
        [UpdateAdderMethod.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.adder = action.payload;
        },
        [UpdateAdderMethod.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.errors = action.payload;
        },

        // Update Adders Status
        [UpdateAdderStatus.pending]: (state) => {
            state.isLoading = true;
        },
        [UpdateAdderStatus.fulfilled]: (state, action) => {
            state.isSuccess = true;
            state.isLoading = false;
            state.adder = action.payload;
        },
        [UpdateAdderStatus.rejected]: (state, action) => {
            state.isError = true;
            state.isLoading = false;
            state.errors = action.payload;
        },
        // Delete Adders
        [DeleteAddreMethod.pending]: (state) => {
            state.isLoading = true;
        },
        [DeleteAddreMethod.fulfilled]: (state, action) => {
            state.isSuccess = true;
            state.isLoading = false;
            state.adder = action.payload;
        },
        [DeleteAddreMethod.rejected]: (state, action) => {
            state.isError = true;
            state.isLoading = false;
            state.errors = action.payload;
        },
        // Get Servuces Types
        [GetAllServiceTypes.pending]: (state) => {
            state.isLoading = true;
        },
        [GetAllServiceTypes.fulfilled]: (state, action) => {
            state.isSuccess = true;
            state.isLoading = false;
            console.log(action)
            state.services = action.payload;
        },
        [GetAllServiceTypes.rejected]: (state, action) => {
            state.isError = true;
            state.isLoading = false;
            state.errors = action.payload;
        },    },
});

export const { adderReset } = AddersSlicev2.actions;
export default AddersSlicev2.reducer;
